export const MARQUEE_SPEED = 40
export const MARQUEE_GRADIENT_WIDTH = 50
